// A tab opened before a deploy (or DNS cutover) can request lazy chunks the new build no
// longer has; one reload picks up the new index.html. The timestamp is never cleared on boot:
// lazy chunks fail after boot, so clearing it there turns a missing chunk into a reload loop.
export const CHUNK_RELOAD_KEY = "billings:chunk-reload-at";
export const CHUNK_RELOAD_WINDOW_MS = 10_000;

export function claimChunkReload(storage, now) {
  try {
    const last = storage.getItem(CHUNK_RELOAD_KEY);
    if (last !== null && now - Number(last) < CHUNK_RELOAD_WINDOW_MS) {
      return false;
    }
    storage.setItem(CHUNK_RELOAD_KEY, String(now));
    return true;
  } catch {
    return false;
  }
}
